import FavouritesInfoCard from "@common/components/ResidenceGeneric/FavouritesInfoCard"
import ImageDisplayCompare from "@common/components/ResidenceGeneric/ImageDisplayCompare"
import { TrashIcon } from "@radix-ui/react-icons"
import TextButton from "@common/ui/TextButton"
import styled from "styled-components"
import { useState } from "react"
import Modal from "@common/ui/Modal"
import { useFavoritesStore } from "@state/favouritesStore"
import { useStore } from "@state/store"

type UnitSingleProps = {
  sections: any[]
  contentControls: any
  selectedRows: any[]
  removeFromFavorites: (unitName: string) => void
  className?: string
}

const UnitSingle = (props: UnitSingleProps) => {
  const { selectedRows } = props
  const { removeFromFavorites } = useFavoritesStore()
  const syncState = useStore((s) => s.syncState)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedUnit, setSelectedUnit] = useState(null)
  const handleModalOpen = (open: boolean, selectedUnit: any) => {
    setIsModalOpen(open)
    setSelectedUnit(selectedUnit)
  }
  const removeSelectedRows = (selectedRow: any) => {
    removeFromFavorites(selectedRow)
    syncState({ selectedRows: [null, null] })
  }
  if (!selectedRows) return null
  return (
    <div className="unit-single-container">
      <div className="unit-single">
        <div className="info-card-container">
          <FavouritesInfoCard unit={selectedRows} />
        </div>

        <div className="image-display-container">
          <ImageDisplayCompare selectedUnit={selectedRows} />
        </div>

        <div className="single-unit-controls">
          <StyledTextButton
            onClick={() => removeSelectedRows(selectedRows)}
            variant="fill"
            style={{
              borderRadius: "2rem",
              padding: "2rem",
              backgroundColor: "var(--secondary)",
            }}
            icon={<TrashIcon />}
            iconPosition="right"
            color="accent"
            className="remove-single"
          >
            Remove from favourites
          </StyledTextButton>
          <TextButton
            className="enlarge-single"
            style={{ backgroundColor: "var(--secondary)" }}
            onClick={() => handleModalOpen(true, selectedRows)}
            variant="fill"
            color="accent"
            icon={<img src="assets/icons/enlarge.png" alt="" />}
          />
        </div>
      </div>
      <Modal
        style={{
          backgroundColor: "var(--primary)",
          height: "90%",
          width: "90%",
        }}
        isFullScreen={false}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      >
        <ImageDisplayCompare
          show={setIsModalOpen}
          selectedUnit={selectedUnit}
        />
      </Modal>
    </div>
  )
}

export default UnitSingle

const StyledTextButton = styled(TextButton)`
  position: absolute;
  bottom: 1em;
  left: 1em;
  height: 4em !important;
  text-transform: capitalize;
`
